import { toast as reactToastify } from "react-toastify";

import Swal from "sweetalert2";

export interface ToastProps {
  variant?: "default" | "destructive";
  title?: string;
  description?: string;
  action?: React.ReactNode;
}

// For backward compatibility
export interface ToastActionElement {
  altText: string;
}

// Function to display SweetAlert2 alert for more interactive alerts
export function toast(props: ToastProps) {
  const { variant, title, description } = props;

  if (variant === "destructive") {
    // Use SweetAlert2 for error alerts
    return Swal.fire({
      title: title || "Error",
      text: description,
      icon: "error",
      confirmButtonColor: "#dc2626",
      confirmButtonText: "Entendido",
      customClass: {
        container: "swal2-z-top",
        popup: "z-[100000]",
      },
      // Strong mobile isolation
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: `rgba(0,0,0,0.6)`,
      heightAuto: false,
      scrollbarPadding: false,
      stopKeydownPropagation: true,
      focusConfirm: true,
      reverseButtons: false,
      buttonsStyling: true,
    });
  } else {
    // Use react-toastify for regular notifications
    return reactToastify(description || title, {
      type: "success",
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }
}

// For compatibility with existing code
export function useToast() {
  return {
    toast,
    dismiss: () => {},
  };
}
